export function trim(string, maxLength) {
  if (string.length <= maxLength) {
    return string;
  } else {
    return string.substring(0, maxLength - 3) + "...";
  }
}

export function FIO(name = "", lastName = "", middleName = "") {

  if (!name && !lastName && !middleName) return "";
  if (!lastName) return name;
  if (!middleName) return `${lastName} ${name}`;
  return `${lastName} ${name} ${middleName}`;
}

export function onlyNumbers(string) {
  return string?.replace(/[^0-9,]/g, "").replace(",", ".");
}
export function replacePointOnComma(string) {
  return string?.replaceAll('.', ',');
}

export default { trim, FIO, onlyNumbers };
